import { DataCardinalities, DataTypes, DataVariants } from "../../../data/DataManager";
import { GridFilterTypes, GridRenderSlots } from "../../../grid/AgGridManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, FieldValueObject, FieldValues, isEmpty } from "../../../Schema";
import { getAndProcessReviewers } from "../../common/external-sources/Reviewers";
import { User } from "../../common/external-sources/Users";
import { sortBy } from "lodash";
import { SchemaContext } from "../../common";
import { EntryTypes } from "./entryType";

export const createReviewers = (context: SchemaContext): FieldSchema => ({
  name: "reviewers",
  grid: {
    displayed: true,
    order: 64,
    filter: GridFilterTypes.TEXT,
    render: GridRenderSlots.REVIEWERS,
    sortable: false,
  },
  display: { displayed: false },
  dataTransform: {
    toGraphql: {
      getter: ({ entryType, reviewers }) => {
        if ([
          EntryTypes.CLUSTER_SUBEQUIPMENT,
          EntryTypes.STANDALONE_EQUIPMENT
        ].includes(entryType as EntryTypes)) {
          if (!isEmpty(reviewers) && Array.isArray(reviewers)) {
            return (reviewers as FieldValueObject[]).map((reviewer) => reviewer?.userId ?? EMPTY_VALUE);
          }
          return EMPTY_VALUE;
        }
        return undefined;
      },
      fields: ["entryType", "reviewers"]
    },
  },
  data: {
    type: DataTypes.OBJECT,
    variant: DataVariants.ENUM,
    cardinality: DataCardinalities.MULTIPLE,
    options: {
      getter: async (values) => {
        const { currentUser, is4epMode, originalValues, belongingToGroup } = values;
        if (is4epMode) {
          const reviewers = await getAndProcessReviewers(
            context.client,
            (currentUser as User).userId,
            ((originalValues ? originalValues : { belongingToGroup }) as FieldValues)?.belongingToGroup as string
          );
          return sortBy(
            reviewers.map((user: User) => ({
              value: user,
              label: (user.givenName && user.familyName) ?
                (user.name ?
                  `${user.givenName} ${user.familyName} - ${user.name}` :
                  `${user.givenName} ${user.familyName}`) :
                (user.email ?? user.userId),
            })),
            "label"
          );
        }
        return [];
      },
      fields: ["currentUser", "is4epMode", "belongingToGroup", "originalValues"],
    },
  },
  validation: {
    required: {
      getter: ({ is4epMode }) => !!is4epMode,
      fields: ["is4epMode"],
    },
  },
  form: {
    label: "Reviewers",
    type: InputTypes.MULTISELECT,
    displayed: {
      getter: ({ is4epMode }) => !!is4epMode,
      fields: ["is4epMode"],
    },
  },
});
